import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion';
import Card from "../components/Card"; // Import your Card component
import CardMobile from "../components/CardMobile";


const Home = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Track scroll position
  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  // Track window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const cardPositions = [
    { left: "25%", top: "10%" },
    { left: "40%", top: "30%" },
    { left: "55%", top: "50%" },
    { left: "85%", top: "60%" },
    { left: "85%", top: "20%" },
    { left: "25%", top: "70%" },
    { left: "50%", top: "80%" },
    { left: "80%", top: "40%" },
    { left: "90%", top: "85%" },
  ];

  const cardVideos = [
    "./assets/projectsvid/sandis-story.mp4",
    "./assets/projectsvid/freedom-is-coming.mp4",
    "./assets/projectsvid/coexist.mp4",
    "./assets/projectsvid/LAPhil.mp4",
    "./assets/projectsvid/TheNewRoad.mp4",
    "./assets/projectsvid/infantry.mp4",
    "./assets/projectsvid/Dance.mp4",
    "./assets/projectsvid/Tonic.mp4",
    "./assets/projectsvid/Domestic.mp4",
  ];

  const cardLinks = [
    "/works/18",
    "/works/13",
    "/works/12",
    "/works/11",
    "/works/17",
    "/works/16",
    "/works/19",
    "/works/4",
    "/works/14",
  ];

  const cardTitles = [
    "Sandi's Story",
    "Freedom is coming",
    "Coexist",
    "SFS - LA Phil",
    "New Road",
    "Infantry",
    "Dance",
    "Tonic",
    "Domestic",
  ];

  const cardDescriptions = [
    "Short Film",
    "Music Video",
    "Video Art",
    "Mini Documentary",
    "Short Film",
    "Short Film",
    "Short Film",
    "Short Film",
    "Short Film",
  ];

  return (
    <div className="home-container">
      {!isMobile && (
        <>
          <Card
            link={"/works/20"}
            videoSrc={"./assets/projectsvid/june.mp4"}
            title={"JUNE"}
            description={"Short Film"}
            style={{
              transform: `translateX(${-scrollPosition * 0.5}px)`,
              opacity: scrollPosition > 75 ? 0 : 1,
              width: "700px",
              height: "398px",
            }}
          />
          {cardPositions.map((position, index) => (
            <Card
              key={index}
              link={cardLinks[index]}
              videoSrc={cardVideos[index]}
              title={cardTitles[index]}
              description={cardDescriptions[index]}
              style={{
                left: position.left,
                top: position.top,
                transform: `translateX(${-scrollPosition * 0.5}px)`,
                opacity: scrollPosition > 76 * index ? 1 : 0,
                transition: "transform 2.5s ease, opacity 2.5s ease",
              }}
            />
          ))}
          <div className="background-text" style={{ opacity: scrollPosition < 1200 ? 1 : 0 }}>
            <div className="line" style={{ opacity: scrollPosition < 200 ? 1 : 0 }}>HIGHER</div>
            <div className="line" style={{ opacity: scrollPosition < 600 ? 1 : 0 }}>LOW</div>
            <div className="line" style={{ opacity: scrollPosition < 900 ? 1 : 0 }}>FILMS</div>
          </div>
          <motion.div
            className="scroll-down"
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: scrollPosition > 100 ? 0 : 1, y: scrollPosition > 100 ? 20 : 0 }}
            transition={{ duration: 0.5 }}
          >
            &#709; Scroll Down &#709;
          </motion.div>
        </>
      )}
      {isMobile && (
        <div className="mobile-container" style={{ display: "flex", flexDirection: "column", alignItems: "center",  gap: "30px" }}>
          {/* Beautiful Title on Top */}
          <div className="background-text" style={{ textAlign: "center", fontSize: "28px", fontWeight: "bold", lineHeight: "1.2", letterSpacing: "2px", marginBottom: "20px" }}>
            <div style={{ opacity: 1, transform: "scale(1.1)", color: "#fff" }}>HIGHER</div>
            <div style={{ opacity: 0.9, transform: "scale(1)", color: "#ddd" }}>LOW</div>
            <div style={{ opacity: 0.8, transform: "scale(0.9)", color: "#aaa" }}>FILMS</div>
          </div>

          {/* Animated Cards */}
          {cardVideos.map((video, index) => (

            <CardMobile
              key={index}
              link={cardLinks[index]}
              index={index}
              videoSrc={video}
              title={cardTitles[index]}
              description={cardDescriptions[index]}
              style={{
                width: "100%",
                borderRadius: "12px",
                backgroundColor: "#222",
                padding: "10px",
              }}
            />
          ))}
        </div>
      )}

    </div>
  );
};

export default Home;
